export const ANALYTICS_CARD_TYPES = {
	HIRES: 'hires-from-referrals',
	RATIO: 'referred-to-hired-ratio',
	VELOCITY: 'referral-velocity',
	ADOPTION: 'employee-adoption',
};
